import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileUpload } from '@app-libs/model';

@Component({
  selector: 'app-input-actions',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './input-actions.component.html',
  styleUrls: ['./input-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputActionsComponent {
  @Input() isUploadButtonDisabled = false;
  @Input() uploadedFile?: FileUpload;
  @Input() fileTooltip = 'Attach pdf';
  @Input() isMobile = false;
  @Input() acceptFileTypes = 'application/pdf';
  @Input() acceptImageTypes = 'image/*,.png,.jpg,.jpeg,.gif,.bmp,.webp';

  @Output() newChat = new EventEmitter<void>();
  @Output() uploadFileClick = new EventEmitter<void>();
  @Output() captureImageClick = new EventEmitter<void>();
  @Output() fileSelected = new EventEmitter<Event>();
  @Output() showComingSoon = new EventEmitter<void>();
  @Output() scrollToBottom = new EventEmitter<void>();
  @Output() testFunction = new EventEmitter<void>();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('imageInput') imageInput!: ElementRef<HTMLInputElement>;

  onNewChatClick(): void {
    this.newChat.emit();
  }

  onUploadFileClick(): void {
    this.acceptFileTypes = 'application/pdf';
    this.fileInput.nativeElement.click();
    this.uploadFileClick.emit();
  }

  onCaptureImageClick(): void {
    this.acceptImageTypes = 'image/*,.png,.jpg,.jpeg,.gif,.bmp,.webp';
    this.imageInput.nativeElement.click();
    this.captureImageClick.emit();
  }

  onFileSelected(event: Event): void {
    this.fileSelected.emit(event);
  }

  onShowComingSoon(): void {
    this.showComingSoon.emit();
  }

  onScrollToBottom(): void {
    this.scrollToBottom.emit();
  }

  onTestFunction(): void {
    this.testFunction.emit();
  }

  resetFileInputs(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    if (this.imageInput) {
      this.imageInput.nativeElement.value = '';
    }
  }
}